// ResourceCard.tsx

import React from 'react';
import { MdLibraryBooks } from "react-icons/md";
import { AnimatePresence, motion } from 'framer-motion';

interface ResourceCardProps {
    title?: string;
    subtitle?: string;
    imageLink?: string;
    tag?: string;
}

const ResourceCard: React.FC<ResourceCardProps> = ({ title, subtitle, imageLink, tag }) => {
    const [hovered, setHovered] = React.useState(false);

    const subtitleVariants = {
        hidden: { opacity: 0, height: 0 },
        visible: { opacity: 1, height: 'auto' }
    };

    return (
        <div
            className="w-[200px] md:w-[300px] font-jarkarta relative rounded-sm flex flex-col justify-between cursor-pointer"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <div className="relative">
                <div className="h-[259px] md:h-[388px] flex justify-center items-center bg-white overflow-hidden">
                    <img src={imageLink} alt={title} className='' />
                </div>
                <div className={`absolute bottom-0 left-0 w-full h-full bg-custom-black transition-opacity duration-200 ${hovered ? 'opacity-50' : 'opacity-0'}`} />
                <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-custom-black to-transparent px-6 pt-8 pb-2">
                    <div className="text-white">
                        <motion.div className="font-bold text-xl mb-2">
                            {title}
                        </motion.div>
                        <AnimatePresence>
                            {hovered && (
                                <motion.div
                                    initial="hidden"
                                    animate="visible"
                                    exit="hidden"
                                    variants={subtitleVariants}
                                    transition={{ duration: 0.2 }}
                                    className="text-sm">
                                    {subtitle}
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                </div>
            </div>
            <div className='border border-custom-gray z-10' />
            <div className='bg-custom-black py-4'>
                <div className='px-6 flex justify-between font-semibold items-center text-white'>
                    <span className={`shadow-2xl inline-block rounded-full px-2 py-1 text-sm font-semibold`}>
                        {tag}
                    </span>
                    <MdLibraryBooks className='text-xl' />
                </div>
            </div>
        </div>
    );
};
export default ResourceCard;
